import React, { FC } from 'react';
import { FormControl, Select, MenuItem, InputLabel, FormHelperText, createStyles, makeStyles, Theme} from '@material-ui/core/';

interface Props {
    label: string;
    initialValue?: string;
    value: string;
    error?: boolean;
    variableError?: string;
    items: Array<any>;
    disabled?: boolean;
    onChange: (e: any, data?: any) => void;
}


const SelectComponent: FC<Props> = (p) => {
    const useStyles = makeStyles((theme: Theme) => 
        createStyles({
            formControl: {
                minWidth: '100%',
            },
            menu: {
                height:300
            }
        })
    );

    const classes = useStyles();

    return (
        <FormControl variant="outlined" className={classes.formControl} error={p.error} disabled={p.disabled}>
            <InputLabel id="select-filled">{p.label}</InputLabel>
            <Select
                MenuProps={{className: classes.menu}}
                autoWidth
                labelId='select-filled'
                id="select-filled"
                value={p.value}
                onChange={p.onChange}
            >
                <MenuItem  dense={true} value=''>{p.initialValue}</MenuItem>
                {
                    p.items.map((item:any, index: number) => (
                    <MenuItem key={index} dense={true} value={item._id ? item._id : item}>{item.name ? item.name : item}</MenuItem>
                    ))
                }
            </Select>
            { p.variableError && <FormHelperText>{p.variableError}</FormHelperText> }
        </FormControl>
    );
}

export default SelectComponent;
